import {
  CButton,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableRow,
} from "@coreui/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import DeleteIcon from "../../icons/DeleteIcon";
import PromptModal from "../../modals/PromptModal";
import { ProfilePictureAvatar } from "../../taxi/Profile_picture_avatar";

interface ReviewTableProps {
  reviews: any[];
  deleteReview: (id: string) => void;
  isDeletingReview: boolean;
}

export default function ReviewTable({
  reviews,
  deleteReview,
  isDeletingReview,
}: ReviewTableProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const [reviewToDeleteId, setReviewToDeleteId] = useState<string | null>(null);
  const openModal = (id: string) => {
    setReviewToDeleteId(id);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setReviewToDeleteId(null);
  };

  const confirmDelete = async () => {
    if (!reviewToDeleteId) return;
    await deleteReview(reviewToDeleteId);
    closeModal();
  };
  return (
    <>
      <CTable responsive>
        <thead>
          <tr>
            <th>Référence du Trajet</th>
            <th>Driver</th>
            <th>Date</th>
            <th>Commentaire</th>
            <th>Note</th>
            <th>Actions</th>
          </tr>
        </thead>
        <CTableBody>
          {reviews.map((review) => {
            return (
              <CTableRow key={review.id}>
                <CTableDataCell className="p-3 text-sm">
                  <Link
                    to={`/rides/${review.rideId}/ridedetails`}
                    state={{ review }}
                  >
                    {review.reference || "N/A"}
                  </Link>
                </CTableDataCell>
                <CTableDataCell>
                  {" "}
                  <ProfilePictureAvatar
                    profilePicture={review.driver?.profilePicture}
                    fullName={review.driver?.fullName}
                    isOnline={review.driver?.driverProfile?.isOnline}
                  />
                  <Link
                    to={`/drivers/${review.driver?.id}`}
                    className="fw-bold m-0"
                  >
                    {review.driver?.fullName}
                  </Link>
                </CTableDataCell>
                <CTableDataCell>
                  {new Date(review.createdAt).toLocaleDateString()}
                </CTableDataCell>
                <CTableDataCell
                  style={{
                    maxWidth: "200px",
                    whiteSpace: "normal",
                  }}
                >
                  {review?.comment || "Aucun commentaire"}
                </CTableDataCell>
                <CTableDataCell>
                  {review?.rating ? `${review.rating}/5` : "-"}
                </CTableDataCell>
                <CTableDataCell>
                  <CButton
                    className="outline-none border-0 bg-transparent"
                    onClick={() => openModal(review.reviewId)}
                  >
                    <DeleteIcon />
                  </CButton>
                </CTableDataCell>
              </CTableRow>
            );
          })}
        </CTableBody>
      </CTable>
      <PromptModal
        open={modalOpen}
        onClose={closeModal}
        onAccept={confirmDelete}
        loading={isDeletingReview}
      />
    </>
  );
}
